import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import TableAndPagination from '../../_common/TableAndPagination/TableAndPagination';
import { getSingleReportRequest } from '../../../store/actions/dashboard';
import { useQuery } from '../../../utils/hooks/useQuery';
import classes from './dashboard.module.scss';
import Button from '../../_common/Form/Buttons/Button';
import Loader from '../../_common/Loader/Loader';
import api from '../../../api/api';
import accountHelpers from '../../../utils/accountHelpers';

let tableHeader = [
  {
    name: 'Specialty',
    path: 'specialty',
  },
  {
    name: 'Patient First Name',
    path: 'patientFirstName',
  },
  {
    name: 'Patient Last Name',
    path: 'patientLastName',
  },
  {
    name: 'Patient Birth Date',
    path: 'patientBirthDate',
  },
  {
    name: 'Patient Sex',
    path: 'patientSex',
  },
  {
    name: 'Patient Street',
    path: 'patientStreet',
  },
  {
    name: 'Patient City',
    path: 'patientCity',
  },
  {
    name: 'Patient State',
    path: 'patientState',
  },
  {
    name: 'Patient Zip',
    path: 'patientZip',
  },
  {
    name: 'Patient Home Phone',
    path: 'patientHomePhone',
  },
  {
    name: 'Patient Mobile',
    path: 'patientMobile',
  },
  {
    name: 'Patient Work',
    path: 'patientWork',
  },
  {
    name: 'Patient Plan Code',
    path: 'patientPlanCode',
  },
  {
    name: 'Patient AnsiBin',
    path: 'patientAnsiBin',
  },
  {
    name: 'Patient PCN',
    path: 'patientPCN',
  },
  {
    name: 'Hub ID',
    path: 'hubId',
  },
  {
    name: 'Patient Insurance ID',
    path: 'patientInsuranceID',
  },
  {
    name: 'Patient Group ID',
    path: 'patientGroupID',
  },
  {
    name: 'Physician First Name',
    path: 'physicianFirstName',
  },
  {
    name: 'Physician Last Name',
    path: 'physicianLastName',
  },
  {
    name: 'Physician DEA',
    path: 'physicianDEA',
  },
  {
    name: 'Physician NPI',
    path: 'physicianNPI',
  },
  {
    name: 'Physician Phone',
    path: 'physicianPhone',
  },
  {
    name: 'Physician Fax',
    path: 'physicianFax',
  },
  {
    name: 'Physician Street',
    path: 'physicianStreet',
  },
  {
    name: 'Physician City',
    path: 'physicianCity',
  },
  {
    name: 'Physician State',
    path: 'physicianState',
  },
  {
    name: 'Physician Zip',
    path: 'physicianZIP',
  },
  {
    name: 'Drug Dispensed',
    path: 'drugDispensed',
  },
  {
    name: 'Quantity',
    path: 'quantity',
  },
  {
    name: 'NDC',
    path: 'NDC',
  },
  {
    name: 'Cost',
    path: 'cost',
    type: 'currency',
  },
  {
    name: 'Days Supply',
    path: 'daysSupply',
  },
  {
    name: 'Sales Code',
    path: 'salesCode',
  },
  {
    name: 'Written Date',
    path: 'writtenDate',
  },
  {
    name: 'Date Filled',
    path: 'dateFilled',
  },
  {
    name: 'Rx No',
    path: 'rxNo',
  },
  {
    name: 'Refill No',
    path: 'refillNo',
  },
  {
    name: 'Refill Remaining',
    path: 'refillsRemaining',
  },
  {
    name: 'Sig',
    path: 'sig',
  },
  {
    name: 'Diagnosis',
    path: 'diagnosis',
  },
  {
    name: 'Primary Insurance Pay',
    path: 'primaryInsurancePay',
    type: 'currency',
  },
  {
    name: 'Secondary Insurance Pay',
    path: 'secondaryInsurancePay',
    type: 'currency',
  },
  {
    name: 'Copay Assistance Amount',
    path: 'copayAssistanceAmount',
  },
  {
    name: 'Patient Pay',
    path: 'patientPay',
    type: 'currency',
  },
  {
    name: 'Total Pay',
    path: 'totalPay',
    type: 'currency',
  },
  {
    name: 'Profit',
    path: 'profit',
    type: 'currency',
  },
  {
    name: 'Margin',
    path: 'margin',
  },
];

const ReportSingle = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const {
    dashboardSingleReport,
    dashboardSingleReportTotalPAge, statusRequest,
  } = useSelector((store) => store.dashboard);
  const { query } = useQuery();
  const [loading, setLoading] = useState(true);
  const [downloadLoad, setDownloadLoad] = useState(false);
  const [requestData, setRequestData] = useState({
    page: 1,
    limit: 15,
  });

  const {
    specialization, zip, rep, start, end, productId, report, name, ndc, status, specialty, incentives,
  } = query;

  useEffect(() => {
    if (accountHelpers.getUser().role === 'Health') {
      tableHeader = tableHeader.filter((t) => t.path !== 'primaryInsurancePay'
        && t.path !== 'secondaryInsurancePay'
        && t.path !== 'copayAssistanceAmount'
      && t.path !== 'totalPay'
      && t.path !== 'profit'
      && t.path !== 'margin');
    }

    if (report !== 'Rep') {
      tableHeader = tableHeader.filter((t) => t.path !== 'specialty');
    }
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);

      await dispatch(getSingleReportRequest({
        [report.toLowerCase()]: ndc || name || 'null',
        start,
        end,
        status,
        filter: {
          specialization, zip, rep, productId, specialty, incentives,
        },
      }, requestData));

      setLoading(false);
    })();
  }, []);

  const onChangePageData = async (path, count) => {
    const newRequestData = { ...requestData, [path]: count };

    if (path === 'limit') {
      newRequestData.page = 1;
    }

    setRequestData((prev) => ({ ...prev, [path]: count }));

    await dispatch(getSingleReportRequest({
      [report.toLowerCase()]: ndc || name || 'null',
      start,
      end,
      status,
      filter: {
        specialization, zip, rep, productId, specialty, incentives,
      },
    }, newRequestData));
  };

  const downloadFile = async () => {
    setDownloadLoad(true);

    await api.getSingleReport({
      [report.toLowerCase()]: ndc || name,
      start,
      end,
      status,
      download: true,
      filter: {
        specialization, zip, rep, productId, specialty, incentives,
      },
    }, requestData, `Top_${report}.xlsx`);

    setDownloadLoad(false);
  };

  const onPatientClick = (id) => {
    if (accountHelpers.getUser().role === 'Admin' || accountHelpers.getUser().role === 'Health') {
      navigate(`/scripts/${id}`);
    }
  };

  return (
    <div className={classes.single_report_wrapper}>
      <div className={classes.single_report_header}>
        <div>
          <h2>{report}</h2>

          <h3>{name}</h3>
        </div>

        <Button
          title="Download"
          downloadButton
          onClick={downloadFile}
          loading={downloadLoad}
        />
      </div>
      {loading && statusRequest === 'request'
        ? <div className={classes.single_report_loader}><Loader /></div>
        : (
          <TableAndPagination
            onClick={onPatientClick}
            onChange={onChangePageData}
            data={dashboardSingleReport}
            header={tableHeader}
            totalPage={+dashboardSingleReportTotalPAge}
            page={+requestData.page - 1}
            limit={+requestData.limit}
          />
        )}

    </div>
  );
};

export default ReportSingle;
